class PriceRangeSlider extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.rangeMinValue = this.querySelector('#range-min-value');
        this.rangeMaxValue = this.querySelector('#range-max-value');
        this.spanMinValue = document.querySelector('#ps2-min-label .min-value');
        this.spanMaxValue = document.querySelector('#ps2-max-label .max-value');
        this.inputMinValue = document.querySelector('input[data-hidden-min]');
        this.inputMaxValue = document.querySelector('input[data-hidden-max]');
        this.rangeElement = this.querySelector('.range');
                                          
        this.MIN_VALUE = 0;
        this.MAX_VALUE = parseInt(this.closest('[data-price-slider2]')?.dataset.max, 10) || 1999;


        this.rangeMinValue.addEventListener('input', this.minRangeInput.bind(this));
        this.rangeMaxValue.addEventListener('input', this.maxRangeInput.bind(this));
        this.setInitalValues();
      
    }

    setInitalValues() {
        //
        const maxThumbPercent = this.getThumbPosition('max');

        if (parseInt(this.rangeMinValue.value) >= parseInt(maxThumbPercent)) {
            this.rangeMinValue.value = maxThumbPercent;
        }

        const percentage = parseInt(this.rangeMinValue.value);
        this.setThumbPosition('min', percentage);
        //
        const minThumbPercent = this.getThumbPosition('min');

        if (parseInt(this.rangeMaxValue.value) <= parseInt(minThumbPercent)) {
            this.rangeMaxValue.value = minThumbPercent;
        }

        const percentageMax = parseInt(this.rangeMaxValue.value);

        this.setThumbPosition('max', percentageMax);
        //
      
        this.spanMinValue.innerHTML = this.inputMinValue.value;
        this.spanMaxValue.innerHTML = this.inputMaxValue.value;
    } 
                                           
                                                
                                          
    valueToPercentage(value) {
        return (value / this.MAX_VALUE) * 100;
    }
                                          
    percentageToValue(percentage) {
        return Math.round((percentage / 100) * this.MAX_VALUE);
    }
                                          
    setThumbPosition(thumbType, percentage) {
        const cssVar =
        thumbType === 'min' ? '--min-thumb-percent' : '--max-thumb-percent';
        const atrVar =
        thumbType === 'min' ? 'data-min-thumb-percent' : 'data-max-thumb-percent';
        this.rangeElement.style.setProperty(cssVar, percentage);
        this.rangeElement.setAttribute(atrVar, percentage);
    }
                                          
    getThumbPosition(thumbType) {
        const atrVar =
        thumbType === 'min' ? 'data-min-thumb-percent' : 'data-max-thumb-percent';
        const val = this.rangeElement.getAttribute(atrVar);
        return val;
    }
                                          
    // validateAndSetValue(input, value, minValue, maxValue) {
    //     if (value < minValue) {
    //     input.value = minValue;
    //     } else if (value > maxValue) {
    //     input.value = maxValue;
    //     }
    //     return parseInt(input.value);
    // }
                                          
    // sanitizeInputValue(input) {
    //     if (!/^\d+$/.test(input.value)) {
    //     input.value = input.value.replace(/[^0-9]/g, '');
    //     }
    // }
                                          
    minRangeInput () {
        const maxThumbPercent = this.getThumbPosition('max');

        if (parseInt(this.rangeMinValue.value) >= parseInt(maxThumbPercent)) {
            this.rangeMinValue.value = maxThumbPercent;
        }

        const percentage = parseInt(this.rangeMinValue.value);
        const value = this.percentageToValue(percentage);

        this.spanMinValue.innerHTML = value;
        this.setThumbPosition('min', percentage);
        this.inputMinValue.value = value;
    }
                                          
    maxRangeInput() {
        const minThumbPercent = this.getThumbPosition('min');

        if (parseInt(this.rangeMaxValue.value) <= parseInt(minThumbPercent)) {
            this.rangeMaxValue.value = minThumbPercent;
        }

        const percentage = parseInt(this.rangeMaxValue.value);
        const value = this.percentageToValue(percentage);

        this.spanMaxValue.innerHTML = value;
        this.setThumbPosition('max', percentage);
        this.inputMaxValue.value = value;
    }
                                         
                                   
}

customElements.define('price-range-slider', PriceRangeSlider);